// extracted by mini-css-extract-plugin
export default {"bed":"bed_option_bed__4paF3","roomTitle":"bed_option_roomTitle__0maZ2","bedIcon":"bed_option_bedIcon__Suz-3"};